import { authService } from '../../features/auth/services/authService';

/**
 * Build backend auth headers with Supabase JWT in the required format.
 * Only use this helper for protected backend endpoints.
 */
export async function getBackendAuthHeaders(
  includeJsonContentType: boolean = true
): Promise<Record<string, string>> {
  const session = await authService.getSession();
  const accessToken = session?.access_token;

  if (!accessToken) {
    throw new Error('Missing Supabase access token');
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  };

  if (includeJsonContentType) {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
}
